import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=6188fdeb&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"
import style0 from "./Factory.vue?vue&type=style&index=0&id=6188fdeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188fdeb",
  null
  
)

export default component.exports